(() => {
  if (window.__byzaynSocialCommentsV2) return;
  window.__byzaynSocialCommentsV2 = true;

  const EMPTY_TITLE = 'Be the first to comment';
  const EMPTY_HELPER = 'Ask about fit, fabric, sizing, or styling.';
  const PLACEHOLDER = 'Write a comment…';
  const PROMPT = 'Ask a question or leave a comment';

  const growTextarea = (textarea) => {
    if (!(textarea instanceof HTMLTextAreaElement)) return;
    textarea.style.height = 'auto';
    const max = matchMedia('(max-width: 749px)').matches ? 96 : 132;
    const next = Math.min(Math.max(textarea.scrollHeight, 44), max);
    textarea.style.height = `${next}px`;
    textarea.style.overflowY = textarea.scrollHeight > max ? 'auto' : 'hidden';
  };

  const prepareComposer = (feed) => {
    feed.querySelectorAll('.bz-social-comment-form').forEach((form) => {
      if (form.dataset.bzCommentsComposerReady === 'true') return;
      form.dataset.bzCommentsComposerReady = 'true';
      const label = form.querySelector('label');
      const textarea = form.querySelector('textarea[name="body"]');
      const button = form.querySelector('button[type="submit"]');
      const helper = form.querySelector('small');

      if (label) label.textContent = 'Add a comment';
      if (textarea instanceof HTMLTextAreaElement) {
        textarea.placeholder = PLACEHOLDER;
        textarea.rows = 2;
        textarea.setAttribute('aria-label', 'Write a comment');
        growTextarea(textarea);
      }
      if (button) button.textContent = 'POST';
      if (helper) {
        helper.textContent = form.matches('[data-bz-guest-comment-form]')
          ? 'Sign in only when posting'
          : '2–500 characters';
      }
    });
  };

  const setProductContext = (feed, card) => {
    if (!(feed instanceof HTMLElement) || !(card instanceof HTMLElement)) return;
    const dialog = feed.querySelector('[data-social-comments-dialog]');
    if (!(dialog instanceof HTMLDialogElement)) return;

    const thumb = dialog.querySelector('[data-bz-comments-thumb]');
    const cardImage = card.querySelector('.bz-social-card__media img');
    if (thumb instanceof HTMLImageElement) {
      if (cardImage instanceof HTMLImageElement) {
        thumb.src = cardImage.currentSrc || cardImage.src;
        thumb.alt = '';
        thumb.closest('.bz-social-dialog__product-media')?.removeAttribute('hidden');
      } else {
        thumb.removeAttribute('src');
        thumb.closest('.bz-social-dialog__product-media')?.setAttribute('hidden', '');
      }
    }
  };

  const updateEmptyState = (feed) => {
    const status = feed.querySelector('[data-social-comments-status]');
    if (!(status instanceof HTMLElement)) return;
    const isEmpty = status.textContent?.trim() === EMPTY_TITLE;
    status.classList.toggle('is-empty', isEmpty);
    if (isEmpty) status.dataset.emptyHelper = EMPTY_HELPER;
    else delete status.dataset.emptyHelper;
  };

  const upgradeDialog = (feed) => {
    if (!(feed instanceof HTMLElement)) return;
    feed.dataset.emptyComments = EMPTY_TITLE;

    const dialog = feed.querySelector('[data-social-comments-dialog]');
    if (!(dialog instanceof HTMLDialogElement)) return;

    const header = dialog.querySelector('.bz-social-dialog__header');
    const title = dialog.querySelector('[data-social-comments-title]');
    if (header && title && !header.querySelector('[data-bz-comments-product]')) {
      const titleWrap = title.parentElement;
      const eyebrow = titleWrap?.querySelector(':scope > p');
      const row = document.createElement('div');
      row.className = 'bz-social-dialog__product-row';
      row.dataset.bzCommentsProduct = '';

      const media = document.createElement('span');
      media.className = 'bz-social-dialog__product-media';
      media.hidden = true;
      const img = document.createElement('img');
      img.dataset.bzCommentsThumb = '';
      img.alt = '';
      media.append(img);

      const copy = document.createElement('span');
      copy.className = 'bz-social-dialog__product-copy';
      if (eyebrow) eyebrow.textContent = 'COMMENTS';
      copy.append(title);
      const prompt = document.createElement('span');
      prompt.className = 'bz-social-dialog__product-prompt';
      prompt.textContent = PROMPT;
      copy.append(prompt);

      row.append(media, copy);
      titleWrap?.append(row);
    }

    prepareComposer(feed);
    updateEmptyState(feed);

    if (feed.dataset.bzCommentsV2Observed === 'true') return;
    feed.dataset.bzCommentsV2Observed = 'true';
    const observer = new MutationObserver(() => {
      prepareComposer(feed);
      updateEmptyState(feed);
    });
    observer.observe(dialog, { childList: true, subtree: true, characterData: true });
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[data-social-comments]');
    if (!button) return;
    const feed = button.closest('byzayn-social-feed');
    const card = button.closest('[data-social-card]');
    if (feed && card) {
      upgradeDialog(feed);
      setProductContext(feed, card);
    }
  }, true);

  document.addEventListener('input', (event) => {
    const target = event.target;
    if (target instanceof HTMLTextAreaElement && target.closest('.bz-social-comment-form')) {
      growTextarea(target);
    }
  });

  const boot = () => {
    document.querySelectorAll('byzayn-social-feed').forEach(upgradeDialog);
    const observer = new MutationObserver((records) => {
      if (records.some((record) => record.addedNodes.length)) {
        document.querySelectorAll('byzayn-social-feed').forEach(upgradeDialog);
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
